import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useHistory } from 'react-router-dom';

import LinkedInDialog from '../components/dialog/LinkedInDialog';
import { getTemplateMetas } from '../utils';

const useStyles = makeStyles(theme => ({
	header: {
		background: 'black',
		marginBottom: 20,

		'& .gm-logo-wrapper': {
			textAlign: 'center',
			padding: 10
		},
		'& .gm-logo': {
			width: 250
		}
	},
	selectTemplateTitle: {
		textAlign: 'center',
		marginBottom: 20
	},
	card: {
		position: 'relative'
	},
	media: {
		height: 0,
		paddingTop: '56.25%' // 16:9
	},
	overlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		backgroundColor: 'rgba(0,0,0,0.5)',
		color: 'white',
		// opacity: 0.7,
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	overlayTitle: {
		textAlign: 'center'
	},
	overlayButton: {
		textAlign: 'center',
		margin: theme.spacing(2)
	}
}));

const SelectTemplateScreen = () => {
	const classes = useStyles();
	const templateMetas = useStoreState(state => state.template.template_metas);
	const setTemplate = useStoreActions(actions => actions.template.setTemplate);
	const setTemplateMetas = useStoreActions(actions => actions.template.setTemplateMetas);
	const history = useHistory();
	const [mouseEnter, setMouseEnter] = useState({});
	const [openLinkedInDialog, setOpenLinkedInDialog] = useState(false);

	useEffect(() => {
		console.log('SelectTemplateScreen useEffect');
		getTemplateMetas().then(({ templateMetasRes }) => {
			setTemplateMetas(templateMetasRes);
		});
	}, [setTemplateMetas]);

	const selectTemplate = temp => () => {
		console.log('selectTemplate', temp);
		setTemplate(temp);
		window.selectedTemplate = temp;
		// setOpenLinkedInDialog(true);
		// go to editor
		history.push('/editor');
	};

	const viewExample = exampleUrl => () => {
		window.open(exampleUrl);
	};

	const onMouseEnter = temp => () => {
		setMouseEnter({});
		setMouseEnter({
			[temp]: !mouseEnter[temp]
		});
	};

	const onMouseLeave = () => {
		setMouseEnter({});
	};

	// if (template) {
	//   history.push('/linkedin');
	// }
	// <CardActionArea onClick={selectTemplate('template1')}>

	const renderEachTemplate = (templateId, templateMeta) => {
		const { name, previewImageUrl } = templateMeta;
		const exampleUrl = `${process.env.REACT_APP_PREVIEW_URL}/${templateId}`;
		return (
			<Card
				className={classes.card}
				onMouseEnter={onMouseEnter(templateId)}
				onMouseLeave={onMouseLeave}
			>
				<CardMedia className={classes.media} image={previewImageUrl} title={name} />
				{mouseEnter[templateId] && (
					<div className={classes.overlay}>
						<div>
							<Typography variant="h6" className={classes.overlayTitle}>
								{name}
							</Typography>
							<div className={classes.overlayButton}>
								<Button
									variant="contained"
									color="primary"
									onClick={selectTemplate(templateId)}
								>
									START EDITING!
								</Button>
							</div>
							<div className={classes.overlayButton}>
								<Button
									variant="contained"
									color="secondary"
									onClick={viewExample(exampleUrl)}
								>
									VIEW EXAMPLE
								</Button>
							</div>
						</div>
					</div>
				)}
			</Card>
		);
	};

	return (
		<>
			<div className={classes.header}>
				<div className="gm-logo-wrapper">
					<img
						alt="GoalsMapper - Redefining Financial Planning"
						className="gm-logo"
						src="/images/logo.png"
					/>
				</div>
			</div>
			<Container>
				<Typography variant="h3" className={classes.selectTemplateTitle}>
					Select a template to get started!
				</Typography>
				<Typography variant="h4" className={classes.selectTemplateTitle}>
					You can change this later
				</Typography>
				<Grid container spacing={2}>
					{templateMetas.map(({ template, meta }) => (
						<Grid item xs={12} sm={6} key={template}>
							{renderEachTemplate(template, meta)}
						</Grid>
					))}
				</Grid>
			</Container>
			{openLinkedInDialog && (
				<LinkedInDialog
					openLinkedInDialog={openLinkedInDialog}
					setOpenLinkedInDialog={setOpenLinkedInDialog}
				/>
			)}
		</>
	);
};

SelectTemplateScreen.propTypes = {};

export default SelectTemplateScreen;
